export default "__VITE_ASSET__YOscBLhP__"